import Opportunity from "./opportunity"
import Project from "./project"
import Transaction from "./transaction"
import { GrossMarginReport } from "./gross-margin-report"
import BudgetLine from "./budget-line"
import { DepartmentLevel } from "./department-level"
import Employee from "./employee"
import { ChipVariant } from "Components/atoms/chip"

export enum DepartmentBillable {
    YES = 'Yes',
    NO = 'No'
}

export const DEPARTMENT_BILLABLE_VARIANT: Record<string, ChipVariant> = {
    [DepartmentBillable.YES]: 'success',
    [DepartmentBillable.NO]: 'danger',
}

export default interface Department {
  id: string
  code: string
  description: string
  parentId?: string | null
  levelId: string
  headId?: string | null
  color?: string | null
  isBillable?: boolean
  createdAt: Date
  updatedAt: Date
  deletedAt?: Date | null

  // Navigation
  parentDepartment?: Department | null
  childDepartments?: Department[]
  opportunities?: Opportunity[]
  projects?: Project[]
  transactions?: Transaction[]
  grossMarginReports?: GrossMarginReport[]
  budgetLines?: BudgetLine[]
  departmentLevel?: DepartmentLevel
  departmentHead?: Employee | null

  // Set by the Department CRUD API only: the logged-in employee's effective
  // permission on this department (via direct grant or hierarchy cascade).
  yourPermission?: string | null
  isGlobalAdmin?: boolean
}
